import React from 'react'
import styled from 'styled-components';
import { useNotifications } from '../../hooks/useNotifications';
import MailIcon from '../Icons/outline/MailIcon';
import { COLORS } from '../../config';
import relativeTimeAgo from '../../utils/relativeTimeAgo';
import ClockIcon from '../Icons/outline/ClockIcon';
import dayjs from 'dayjs'
import AdvancedFormat  from 'dayjs/plugin/advancedFormat'
import LocalizedFormat  from 'dayjs/plugin/localizedFormat'

const Styles = styled.div`
  .logo {
    clip-path: polygon(0% 0%, 49% 0, 100% 50%, 51% 100%, 0% 100%);
  }
`;

function NotificationCard({ className, notification }) {
  const notificationDetails = useNotifications(notification.type);

  dayjs.extend(AdvancedFormat)
  dayjs.extend(LocalizedFormat)
  
  return (
    <Styles>
      <div className={`w-full md:p-5 rounded px-6 py-4  ${className}`}>
        <div className='text-secondary font-semibold text-xl'>{dayjs(notification.created_at).format('dddd, MMMM Do')}</div>
        <div className='flex mt-1'>
          <div className='logo bg-gray-200 py-4 pr-4 flex items-center'>
            <MailIcon className='px-2' stroke={COLORS.colorPrimary}/>
          </div>
          <div className='flex-grow ml-6 whitespace-normal'>
            <p className='text-gray-500'>
              {notificationDetails.body}
            </p>
            <p onClick={notificationDetails.onClick} className='text-primary inline font-semibold cursor-pointer hover:text-primary-lightplus'>
              {notificationDetails.button}
            </p>
            <div className='flex items-center'>
              <ClockIcon  size='h-5 w-5' stroke={COLORS.colorPrimary}/> 
              <span className='ml-1 text-gray-400 flex'>
                {relativeTimeAgo(notification.created_at)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </Styles>
  )
}

export default NotificationCard
